import { useAppConfig } from '#apps/client-web/app/config/app.browser';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { PageErrorBoundary } from '#apps/client-web/app/components/page-error-boundary';
import { useNavigateReload } from '#apps/client-web/app/hooks/use-nagivate-reload';

import { useSplashPageViewModel } from './splash-page.view-model';
import { SplashPageContainer } from './splash-page.container';

export const SplashPage = () => {
  const logger = useLogger('pages/splash');

  const appConfig = useAppConfig();

  const onReload = useNavigateReload({ logger });

  const viewModel = useSplashPageViewModel({
    appConfig,
  });

  return (
    <PageErrorBoundary onActionClick={onReload}>
      <SplashPageContainer viewModel={viewModel} />
    </PageErrorBoundary>
  );
};
